<template>

  <div>

    <div v-if="osName === 'Windows' && (physicalResolutionErr === true || screenResolutionErr === true)">
      <span>Your machine resolution should be at least 1024 * 768 to start the test
        with headstart. To change the resolution, follow the steps given below.
      </span>
      <br /><br />
      <ol>
        <li>
          <span>Open Settings</span>
          <br /><br />
        </li>
        <li>
          <span>Click on ‘System’</span>
          <br /><br />
        </li>
        <li>
          <span>Click on  the ‘Display’ option from the left pane</span>
          <br /><br />
          <span>
            <b>Check 1</b>: Check if ‘Change the size of text, apps and other items’ is set to the ‘Recommended’ option. If not, select that option and follow step 4
          </span>
          <br /><br />
        </li>
        <li>
          <span>Select ‘Keep Changes’ in the pop-up window</span>
          <br /><br />
          <span>
            <b>Check 2</b>: Check if ‘System Resolution’ is set to the ‘Recommended’ option. If not, select that option and follow step 4 (If the recommended option is less than 1024*768, you will need to change your machine to take the test)
          </span>
          <br /><br />
        </li>
        <li>
          <span>Come back to the HeadStart test website and click on Refresh</span>
          <br /><br />
        </li>
      </ol>
    </div>

    <div v-else-if="osName === 'Linux' && (physicalResolutionErr === true || screenResolutionErr === true)">
      <span>Your machine resolution should be at least 1024 * 768 to start the test
        with headstart. To change the resolution, follow the steps given below.
      </span>
      <br /><br />
      <ol>
        <li>
          <span>Open Settings</span>
          <br /><br />
        </li>
        <li>
          <span>Search for ‘Displays’ in the left panel and click on it</span>
          <br /><br />
        </li>
        <li>
          <span>Click on the ‘Resolution’ field</span>
          <br /><br />
          <span>
            <b>Check 1</b>: Check if the top-most option is selected. If not, select the top-most and follow steps 4 and 5 (If the top-most option is less than 1024*768, you will need to change your machine to take the test)
          </span>
          <br /><br />
        </li>
        <li>
          <span>Click on Apply on top-right corner of the window</span>
          <br /><br />
        </li>
        <li>
          <span>Select ‘Keep Changes’ in the pop-up window</span>
          <br /><br />
          <span>
            <b>Check 2</b>: Check if Scale is set to 100%. If not, click on 100% and follow steps 4 and 5
          </span>
          <br /><br />
        </li>
        <li>
          <span>Come back to the HeadStart test website and click on Refresh</span>
          <br /><br />
        </li>
      </ol>
    </div>

    <div v-else-if="osName === 'Mac'">
      <span>Your machine resolution should be at least 1024 * 768 to start the test
        with headstart. To change the resolution, follow the steps given below.
      </span>
      <br /><br />
      <ol>
        <li>
          <span>Open System Preferences</span>
          <br /><br />
        </li>
        <li>
          <span>Click on ‘Display’</span>
          <br /><br />
        </li>
        <li>
          <span>Click on ‘Default for display’ as one of the options for Resolution</span>
          <br /><br />
        </li>
        <li>
          <span>Come back to the HeadStart test website and click on Refresh</span>
          <br /><br />
        </li>
      </ol>
    </div>

    <div v-if="zoomLevelErr === true">
      <span>With Mouse -</span>
      <br /><br />
      <ol>
        <li>
          <span>Click on the kebab menu (፧) on the right top of the browser screen.</span>
          <br /><br />
        </li>
        <li>
          <span>Find ‘Zoom’ option and set it to 100%.</span>
          <br /><br />
        </li>
        <li>
          <span>Refresh the test page.</span>
        </li>
      </ol>
      <br /><br />
      <span>With Keyboard -</span>
      <br /><br />
      <ol>
        <li>
          <span>Press the Ctrl key followed by Minus (-) and Plus (+) keys to decrease OR increase the magnification respectively.</span>
          <br /><br />
        </li>
        <li>
          <span>Set it to 100%</span>
          <br /><br />
        </li>
        <li>
          <span>Refresh the test page.</span>
          <br /><br />
        </li>
      </ol>
    </div>

  </div>

</template>

<script>
export default {
  name: 'FaqScalableDescription',
  props: ['osName', 'zoomLevelErr', 'screenResolutionErr', 'physicalResolutionErr']
}
</script>